import {ChangeDetectionStrategy, Component, computed, DestroyRef, effect, Inject, Injectable, Signal, signal} from "@angular/core";
import {AkseptertSignaturmetode, DokumentId, DokumentSignatarerModell, DokumentSignatarModell, DokumentVersjonModell, GruppeId, GruppeMedlemListeModell, HtmlTekst, LitenIkkeTomStreng, OppdaterSignatarerSpesifikasjon} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed, toSignal} from "@angular/core/rxjs-interop";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatCheckbox} from "@angular/material/checkbox";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {MatTooltip} from "@angular/material/tooltip";
import {MedlemmerListevisningKompaktKomponent} from "../../../medlem/komponenter/medlemmer-listevisning-kompakt/medlemmer-listevisning-kompakt";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {SigneringVelgAksepterteMetoderKomponent} from "../../../signering/komponenter/signering-velg-aksepterte-metoder/signering-velg-aksepterte-metoder";
import {TranslateModule} from "@ngx-translate/core";
import {VelgMedlemmerKomponent} from "web-ng2/delt/komponenter/skjema/velg-medlemmer/velg-medlemmer";
import {SubmitButtonKomponent} from "web-ng2/delt/komponenter/skjema/submit-button/submit-button";
import {MedlemListevisningKompaktKomponent} from "../../../medlem/komponenter/medlem-listevisning-kompakt/medlem-listevisning-kompakt";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {erIkkeTomListe, erLikeListerIgnorerRekkefølge} from "felles-ng2/støttefunksjoner/lister";
import {asynkArbeidPågårSignal, standardMinimumVarighetKonfig} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {firstValueFrom, Observable} from "rxjs";
import {mapTilData, terminerEtterFørsteRequestRespons} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {inneholderEntitetBasertPåId, somEntitetId} from "felles-ng2/modell/modellHjelpere";
import {i18n, I18nTekst, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {RopertKomponent} from "web-ng2/delt/komponenter/ropert/ropert";
import {map} from "rxjs/operators";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {fadeInnUtAnimasjon} from "web-ng2/delt/animasjoner";
import {TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";
import {DokumentSigneringDatatjeneste, SendTilSigneringValideringsresultatDLM, valideringsfeilSomTekst} from "felles-ng2/tjenester/datalager/DokumentSigneringDatatjeneste";
import {tomDokumentSignatarerModell} from "felles-ng2/modell/tommeModeller";
import {SigneringBekreftSlettSignaturerDialogKomponent, SigneringBekreftSlettSignaturerDialogRespons} from "../../../signering/modale/signering-bekreft-slett-signaturer-dialog/signering-bekreft-slett-signaturer-dialog";
import {MeldingTilBrukerNg2} from "felles-ng2/tjenester/MeldingTilBrukerNg2";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";

const debug = initDebugger('DokumentSendTilSigneringDialogKomponent');

/**
 * Dialog med skjema for redigere signatarer på dokument sendt til signering.
 */
@Component({
    selector: 'dokument-rediger-til-signering-dialog',
    templateUrl: 'dokument-rediger-til-signering-dialog.html',
    styleUrl: 'dokument-rediger-til-signering-dialog.scss',
    animations: [fadeInnUtAnimasjon('0.5s')],
    imports: [
        MatButton,
        MatCheckbox,
        MatDialogActions,
        MatDialogContent,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatLabel,
        MatToolbar,
        MatTooltip,
        MedlemmerListevisningKompaktKomponent,
        ReactiveFormsModule,
        SigneringVelgAksepterteMetoderKomponent,
        TranslateModule,
        VelgMedlemmerKomponent,
        SubmitButtonKomponent,
        MedlemListevisningKompaktKomponent,
        FormaterZonedDateTimePipe,
        FormsModule,
        RopertKomponent,
        VisSpinnerDirektiv,
        InlineMeldingKomponent,
        TittelVerdiKomponent,
        VerdiKomponent,
        RiktekstRedigeringKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentRedigerTilSigneringDialogKomponent {

    static vis(dialog: MatDialog, dokumentversjon: DokumentVersjonModell) {
        return dialog.open<DokumentRedigerTilSigneringDialogKomponent, DialogParametre, DokumentRedigerTilSigneringDialogRespons>(DokumentRedigerTilSigneringDialogKomponent,
          {
              data: {dokumentversjon} as DialogParametre,
              disableClose: true,
              ariaLabelledBy: 'dokument-rediger-til-signering-dialog-tittel',
              minHeight: 550,
              maxWidth: 700
          });
    }

    dokumentversjon: DokumentVersjonModell; //settes via DialogParametre

    skjema = new FormGroup({
        signatarer: new FormControl<GruppeMedlemListeModell[]>([], {nonNullable: true, validators: Validators.required}),
        beskjed: new FormControl<HtmlTekst>('', {nonNullable: true, validators: FeltValidatorer.htmlTekst}),
        signaturmetoder: new FormControl<AkseptertSignaturmetode[]>([], {nonNullable: true, validators: Validators.required}),
        huskSignaturmetodeValg: new FormControl(false, {nonNullable: true})
    });

    modus = signal<'rediger' | 'bekreft'>('rediger');
    signaturmetoderEndret = computed(() => !erLikeListerIgnorerRekkefølge(this.signaturmetoderSattPåGruppe(), this.signaturmetoderValgt()));
    valgbareMedlemmer: Signal<GruppeMedlemListeModell[]>;
    signatarer: Signal<DokumentSignatarerModell>;
    nyeSignatarer = signal<GruppeMedlemListeModell[]>([]);
    slettedeSignatarer = signal<DokumentSignatarModell[]>([]);
    slettedeSignaturer = computed(() => this.slettedeSignatarer()
      .filter(slettetSignatar => slettetSignatar.harSignert));
    valideringsfeil = signal<string[]>([]);

    laster = asynkArbeidPågårSignal();
    lagrer = asynkArbeidPågårSignal(standardMinimumVarighetKonfig());

    private signaturmetoderSattPåGruppe = signal<AkseptertSignaturmetode[]>([])
    private signaturmetoderValgt = toSignal(this.skjema.controls.signaturmetoder.valueChanges, {initialValue: []});

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<DokumentRedigerTilSigneringDialogKomponent, DokumentRedigerTilSigneringDialogRespons>,
                private avhengigheter: DokumentRedigerTilSigneringDialogKomponentAvhengigheter,
                private oversettelser: Oversettelser,
                private meldingTilBruker: MeldingTilBrukerNg2,
                private dialog: MatDialog,
                private destroyRef: DestroyRef) {
        this.dokumentversjon = parametre.dokumentversjon;
        this.signaturmetoderSattPåGruppe.set(this.dokumentversjon.aksepterteSignaturmetoder);
        this.signatarer = toSignal(this.avhengigheter.signatarer(this.dokumentversjon.dokumentId), {initialValue: tomDokumentSignatarerModell()});
        this.valgbareMedlemmer = toSignal(this.avhengigheter.gruppeMedlemmer(this.dokumentversjon.gruppeId), {initialValue: []});

        this.oppdaterSkjema();
    }

    harSignert(medlem: GruppeMedlemListeModell) {
        return this.signatarer().signatarer.find(s => s.medlem.id == medlem.id)?.harSignert ?? false;
    }

    bekreftOppdaterSignatarer() {
        this.modus.set('bekreft');
    }

    tilbakeTilRedigerSignatarer() {
        this.modus.set('rediger');
    }

    async oppdaterSignatarer() {
        let årsak = undefined;
        if (erIkkeTomListe(this.slettedeSignaturer())) {
            const respons = await this.bekreftSlettSignaturer();
            if (!respons.utfør) return;
            årsak = respons.årsak;
        }
        return this.utførOppdaterSignatarer(årsak);
    }

    avbryt() {
        this.dialogRef.close(false);
    }

    ferdig() {
        this.dialogRef.close(true);
    }

    //private hjelpemetoder

    private async oppdaterSkjema() {
        this.skjema.controls.signaturmetoder.setValue(this.dokumentversjon.aksepterteSignaturmetoder);
        effect(() => this.skjema.controls.signatarer.setValue(this.signatarerSomMedlemmer()));

        this.skjema.controls.signatarer.valueChanges
          .pipe(
            map(oppdaterte => oppdaterte.filter(oppdatert => !inneholderEntitetBasertPåId(this.signatarerSomMedlemmer(), oppdatert))),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(medlemmer => this.nyeSignatarer.set(medlemmer));

        this.skjema.controls.signatarer.valueChanges
          .pipe(
            map(oppdaterte => this.signatarer().signatarer.filter(eksiserende => !inneholderEntitetBasertPåId(oppdaterte, eksiserende.medlem))),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(signatarer => this.slettedeSignatarer.set(signatarer));
    }

    private signatarerSomMedlemmer(): GruppeMedlemListeModell[] {
        return this.signatarer().signatarer.map(s => s.medlem);
    }

    private somOppdaterSpesifikasjon(årsak: LitenIkkeTomStreng | undefined): OppdaterSignatarerSpesifikasjon {
        const verdier = this.skjema.value;
        return {
            signatarer: verdier.signatarer!.map(somEntitetId),
            beskjed: verdier.beskjed!,
            aarsak: årsak,
            signaturmetoder: verdier.signaturmetoder!,
            huskSignaturmetodeValg: verdier.huskSignaturmetodeValg!,
        };
    }

    private async utførOppdaterSignatarer(årsak: LitenIkkeTomStreng | undefined) {
        const valideringsresultat = await this.lagrer.utfør(() =>
          this.avhengigheter.oppdaterSignatarer(this.dokumentversjon, this.somOppdaterSpesifikasjon(årsak)));
        if (valideringsresultat.harFeil) {
            this.valideringsfeil.set(valideringsfeilSomTekst(valideringsresultat, this.valgbareMedlemmer())
              .map(feil => feil.oversett(this.oversettelser)));
            return;
        }
        this.meldingTilBruker.infomelding(new I18nTekst(i18n("Signeringsinformasjon for '{navn}' har blitt oppdatert"), {navn: this.dokumentversjon.pdfFilnavn!}));
        this.ferdig();
    }

    private async bekreftSlettSignaturer(): Promise<SigneringBekreftSlettSignaturerDialogRespons> {
        const respons = await firstValueFrom(SigneringBekreftSlettSignaturerDialogKomponent.vis(this.dialog, this.slettedeSignaturer())
          .beforeClosed());
        return respons!;
    }
}


export type DokumentRedigerTilSigneringDialogRespons = boolean;

export type DialogParametre = { dokumentversjon: DokumentVersjonModell; };

@Injectable()
export class DokumentRedigerTilSigneringDialogKomponentAvhengigheter {

    constructor(private dokumentSigneringDatatjeneste: DokumentSigneringDatatjeneste, private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste) {
    }

    gruppeMedlemmer(id: GruppeId): Observable<GruppeMedlemListeModell[]> {
        return this.gruppemedlemDatatjeneste.finnTilgjengeligeMedMeta(id)
          .pipe(terminerEtterFørsteRequestRespons(), mapTilData());
    }

    signatarer(id: DokumentId): Observable<DokumentSignatarerModell> {
        return this.dokumentSigneringDatatjeneste.hent(id);
    }

    oppdaterSignatarer(dokumentversjon: DokumentVersjonModell, spesifikasjon: OppdaterSignatarerSpesifikasjon): Promise<SendTilSigneringValideringsresultatDLM> {
        return this.dokumentSigneringDatatjeneste.oppdaterSignatarer(dokumentversjon, spesifikasjon);
    }
}

